import type { TopologyGraphPreset } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphState } from 'components/Graph/GraphState';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';
import { selectPresets } from './selectPresets';

/**
 * Get original copy of current preset draft as it was last saved/retrieved from API
 */
export const selectOriginalTopologyPreset: (
  s: GraphState,
) => TopologyGraphPreset | undefined = createScopedSelector(() =>
  createSelector(
    selectPresets,
    prop('layoutSettings', 'presetDraft'),
    (presets, presetDraft) =>
      presets.find((item) => item.id === presetDraft.id),
  ),
);
